import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TableCell, TableRow, Chip } from '@mui/material'

import { WageringLibraryColumnProps } from '@/views/bonus-engine/hooks/types'
import useHasAccess from '@/hooks/use-access.hook'
import { RoleType } from '@/enums'

import {
  TableMenuButtonComponent,
  TableMenuComponent,
  TableMenuOptions,
} from '@/views/components'

type Props = {
  row: WageringLibraryColumnProps
  handleEditWagering: (id: number) => void
  handleDeleteWagering: (
    wageringId: string,
    anchorPosition: {
      top: number
      left: number
    },
  ) => void
}

export const WageringRowComponent = ({
  row,
  handleDeleteWagering,
  handleEditWagering,
}: Props) => {
  const { t } = useTranslation()

  const { hasAccess } = useHasAccess()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const canDelete = !hasAccess(RoleType.AGENT) && !row.isBlocked

  const canEdit = !hasAccess(RoleType.AGENT)

  const handleClickButton = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    type: TableMenuOptions,
  ) => {
    const anchorPosition = {
      top: anchorEl?.getBoundingClientRect().top || event.clientY,
      left: anchorEl?.getBoundingClientRect().left || event.clientX,
    }
    type === 'delete' && handleDeleteWagering(row.id.toString(), anchorPosition)
    type === 'edit' && handleEditWagering(row.id)

    setAnchorEl(null)
  }

  return (
    <>
      <TableRow hover role="checkbox">
        <TableCell>
          <Chip
            variant="filled"
            size="medium"
            label={t(`${row.isBlocked ? 'labels.true' : 'labels.false'}`)}
            className={`${row.isBlocked ? 'green' : 'red'}`}
            sx={{ width: '100%' }}
          />
        </TableCell>
        <TableCell>{row.Name}</TableCell>
        <TableCell>{`${row.percentage}%`}</TableCell>
        <TableMenuButtonComponent setAnchorEl={setAnchorEl} />
      </TableRow>
      <TableMenuComponent
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        handleClickButton={handleClickButton}
        canDelete={canDelete}
        canEdit={canEdit}
      />
    </>
  )
}
